module.exports = __webpack_public_path__ + "static/jennifer-lawrence-4150ab773e9b00769b981d3f4308e031.jpg";